import { useStudentStore } from "../../hooks/use-student-store";
import { GraduationCapIcon } from "lucide-react";

const StudentHeader = () => {
  const { preLesson } = useStudentStore();

  return (
    <div>
      <header className="bg-[#1a3a5c] px-8 py-3">
        <div className="flex items-center max-w-[1400px] mx-auto">
          <div className="flex items-center gap-3">
            <GraduationCapIcon className="size-6 text-white" />
            <span className="text-xl font-bold tracking-tight">
              <span className="text-white">High </span>
              <span className="text-[#E4BA07] italic">Impact </span>
              <span className="text-white">Class</span>
            </span>
          </div>
        </div>
      </header>
      {preLesson && (
        <div className="bg-white border-b border-gray-200 px-8 py-3">
          <div className="max-w-[1400px] mx-auto">
            <div className="text-sm text-gray-600">
              <span>Pre-Lesson Activity</span>
              <span className="mx-2 text-gray-400">&gt;</span>
              <span className="text-gray-900 font-medium">{preLesson.topic || preLesson.title}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentHeader;
